<template>
  <div class="autograph">
    <div class="body">
      <h1>Token获取过程</h1>
      <h2>1、筛选</h2>
      <p>获取所有请求参数如用户账号，用户密码，用户Client Id和Client Secret。</p>
      <h2>2、拼接</h2>
      <p>将Client Id和Client Secret用冒号连接，然后用Base64对其进行编码。最后用Basic加一个空格与得到的字符串进行拼接，得到Authorization。</p>
      <h2>3、请求</h2>
      <p>将拼接后的参数放入Post请求头中，设置请求头请求参数类型为application/json.将用户名和密码处理成json字符串，设置为post请求参数，发送post请求。</p>
      <h2>4、解析</h2>
      <p>将Post的请求的返回值解析出来，得到data字段中的Token字符串。</p>
      <h1>Token有效期</h1>
      <h2>1、有效期12小时</h2>
      <h1>Token 刷新</h1>
      <h2>1、重复Token获取过程</h2>
    </div>
  </div>
</template>
<script type="text/babel">

export default {
  components: {
  },
  data: function () {
    return {
    }
  },
  name: 'autograph',
  async mounted () {
  },
  methods: {

  }
}
</script>
<style scoped>

</style>
<style>
  .autograph{
    background: #F7F7F7;
    overflow: hidden;
  }
  .autograph .body{
    width: 1200px;
    height: 900px;
    margin: 60px auto;
    padding: 30px 60px;
    background: #FFFFFF;
    box-shadow:0px 5px 10px 0px rgba(0, 0, 0, 0.08);
  }

  .autograph .body h1{
    font-size:24px;
    font-family:MicrosoftYaHei-Bold;
    font-weight:bold;
    color:#333333;
    margin: 35px;
  }

  .autograph .body h2{
    font-size:18px;
    font-family:MicrosoftYaHei-Bold;
    font-weight:bold;
    color:#333333;
    margin: 20px 55px;
  }

  .autograph .body p{
    font-size:14px;
    font-family:MicrosoftYaHei-Bold;
    font-weight:600;
    color:#333333;
    margin: 20px 85px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/front/autograph/index.vue